export default {
  EMPLOYEES: (state) => state.employees,
  GET_EMPLOYEES_DATA: (state) => state.employees,
};
